import type { MaskitoOptions } from '@maskito/core'
import { Ref, useImperativeHandle, useRef } from 'react'

import { BaseInput, BaseInputProps } from '../BaseInput'

// Date Mask
const options: MaskitoOptions = {
  mask: [/\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
}

export interface SingleDateInputProps extends Omit<BaseInputProps, 'onChange'> {
  onChange?: (value: string) => void
  ref?: Ref<HTMLInputElement>
}

export const SingleDateInput = ({
  onChange,
  ref,
  ...props
}: SingleDateInputProps) => {
  const internalRef = useRef<HTMLInputElement>(null)

  useImperativeHandle(ref, () => internalRef.current!)

  return (
    <BaseInput
      placeholder="mm-dd-yyyy"
      ref={internalRef}
      maskOptions={{
        ...options,
        postprocessors: [
          args => {
            // We create our own onChange because maskquito programmatically updates the value and does not emmit input events.
            if (onChange) onChange(args.value)
            return args
          },
        ],
      }}
      {...props}
    />
  )
}
